import React, {createContext, useState} from "react";
import Inbox from "ui/page/Inbox";
import MobileInbox from "ui/page/MobileInbox";
import Messages from "./Messages";
import useMediaQuery from "utilities/useMediaQuery";
import {useFeatureFlags} from "utilities/featureUtil";

const defaultContext = {
  appliedFilters: [],
  setAppliedFilters: () => {},
  customFields: [],
  setCustomFields: () => {},
  threads: [],
  setThreads: () => {},
  filtersOpen: false,
  setFiltersOpen: () => {},
  searchText: "",
  setSearchText: () => {},
  stageCounts: null,
  setStageCounts: () => {},
  predictedResponse: null,
  setPredictedResponse: () => {},
  startReached: {},
  setStartReached: () => {},
  guestUpdateInProgress: false,
  setGuestUpdateInProgress: () => {},
  mobileThreadListPosition: 0,
  setMobileThreadListPosition: () => {},
};
export const InboxContext = createContext(defaultContext);

const MessagesPage = () => {
  const flags = useFeatureFlags();
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [customFields, setCustomFields] = useState({});
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const [threads, setThreads] = useState([]);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [stageCounts, setStageCounts] = useState(null);
  const [predictedResponse, setPredictedResponse] = useState(null);
  const [startReached, setStartReached] = useState({});
  const [guestUpdateInProgress, setGuestUpdateInProgress] = useState(false);
  const [mobileThreadListPosition, setMobileThreadListPosition] = useState(0);

  const providerData = {
    appliedFilters,
    setAppliedFilters,
    customFields,
    setCustomFields,
    threads,
    setThreads,
    filtersOpen,
    setFiltersOpen,
    searchText,
    setSearchText,
    stageCounts,
    setStageCounts,
    predictedResponse,
    setPredictedResponse,
    startReached,
    setStartReached,
    guestUpdateInProgress,
    setGuestUpdateInProgress,
    mobileThreadListPosition,
    setMobileThreadListPosition,
  };

  const getContent = () => {
    if (!flags.newInbox) return <Messages />;
    if (isDesktop) return <Inbox />;
    if (flags.newInboxMobile) return <MobileInbox />;
    return <Messages />;
  };

  return (
    <InboxContext.Provider value={providerData}>
      {getContent()}
    </InboxContext.Provider>
  );
};

export default MessagesPage;
